import React, { FunctionComponent } from 'react'

import styled from 'styled-components/native'

import { tID } from '../../utils/utils'
import { Image } from '../image/Image'

const ImageContainer = styled(Image)<{ size: string }>(({ size }) => ({
  width: size,
  height: size,
}))

export const EmailIllustrationIcon: FunctionComponent<EmailIllustrationIconProps> = ({ size = 48 }) => {
  const sizeInPixels = `${size}px`
  return (
    <ImageContainer
      size={sizeInPixels}
      testID={`${tID('EmailIllustrationIcon')}`}
      source={require('../../assets/email_illustration_icon.png')}
    />
  )
}

type EmailIllustrationIconProps = {
  size?: number
}
